<kendo-card class="farlinkmoni-card" *ngIf="farLink">
  <kendo-card-header class="k-hstack">
    <div>
      <h1 kendoCardTitle><kendo-icon name="home"></kendo-icon> Farlink </h1>
      <p kendoCardSubtitle> Global information  </p>

    </div>
  </kendo-card-header>
  <hr kendoCardSeparator/>
  <kendo-card-body>



<code>
      Total field: Found: {{ farLink.aantalVeldStations }} Need:  {{ farLink.vereisteVeldStations }}     <br/>
      Total fast: Found: {{ farLink.aantalFastlinks }} Need:  {{ farLink.vereisteFastlinks }}     <br/>
      Total Di: {{ farLink.aantalDi }}<br/>
      Total Do: {{ farLink.aantalDo }}<br/>
      Total Ai: {{ farLink.aantalAi }}<br/>
      Total Ao: {{ farLink.aantalAo }}<br/>
</code>
  </kendo-card-body>

  <kendo-card-footer >

  <app-fast-link-blue-print-updater></app-fast-link-blue-print-updater>
  </kendo-card-footer>

</kendo-card>






